import { AppState } from '@/store';

export const selectIsChatOpen = (state: AppState) => state.chatState.isOpen;
